import React from "react";

import { moneyFormat } from "./format";
import OnePanel from "./OnePanel";
import Text from "./Text";

const MarketingNoUnitsSold1 = ({ financials, round }) => (
  <OnePanel title="No Units Sold - Insufficient Capital">
    <Text>
      Your business weren’t able to sell any units of the following products
      this round because your cash balance of{" "}
      {moneyFormat(
        financials["net_cash_balance_from_finance"] + financials["prev_cash"]
      )}{" "}
      was not sufficient to execute your total spending request of{" "}
      {moneyFormat(financials["net_cash_balance_from_opinv"])} in Year {round}.
      Therefore, your requests (i.e. decisions) were not accepted. Going
      forward, please ensure that Finance has sufficient capital.
    </Text>
  </OnePanel>
);

export default MarketingNoUnitsSold1;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingNoUnitsSold1.js